// script looks for <div>s with a data-admanager attribute
// extracts data-slot, data-size and data-div attributes
// calls googletag commands to init ads from Google Ad Manager

function handleDOMContentLoaded() {
  // Get current script tag and its data-pid
  const currentScript = document.currentScript;
  const pageId = currentScript ? currentScript.getAttribute('data-pid') : null;
  
  if (!window.googletag) { window.googletag = { cmd: [] }; }
  
  // Set targeting ONCE, outside the loop
  googletag.cmd.push(function() {
    if (pageId) {
      googletag.pubads().setTargeting("page_id", pageId);
    }
  });
  
  // Define all slots first
  const actionElements = document.querySelectorAll('[data-admanager]');
  actionElements.forEach(element => {
    const slot = element.dataset.slot;
    const size = element.dataset.size;
    let sizeArray;
    
    // Check if the size string is a JSON array (e.g., "[[970,90],[728,90]]")
    if (size.trim().startsWith('[')) {
      try {
        sizeArray = JSON.parse(size);
      } catch (e) {
        console.error('Error parsing data-size as JSON:', size, e);
        sizeArray = [];
      }
    } else {
      // Otherwise assume a simple comma-separated string (e.g., "970,90")
      sizeArray = size.split(',').map(s => +s);
    }
    
    const div = element.dataset.div;
    
    googletag.cmd.push(function() {
      googletag.defineSlot(slot, sizeArray, div).addService(googletag.pubads());
    });
  });
  
  // Enable services ONCE after all slots are defined
  googletag.cmd.push(function() {
    googletag.pubads().enableSingleRequest();
    googletag.enableServices();
    
    // Display all ads
    actionElements.forEach(element => {
      const div = element.dataset.div;
      googletag.display(div);
    });
  });
}

if (document.readyState === "loading") { // Loading hasn't finished yet
  document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
} else { // `DOMContentLoaded` has already fired
  handleDOMContentLoaded();
}